import TemplateView from '../../../../../../TemplateView'
import {getHolidays, getImportedHolidayDatess, getPanelSelectedYear, getSorting, isListTransformed, isShownHolidayList} from '../selectors'
import {changeSort, setListTransformed} from '../actions'
import {connect} from '../../../../../../redux/utils'
import {bindActionCreators} from 'redux'
import messageResource from '../../../../../../messageResource'
import {createHolidayListObject, createHolidaysArray, getSortedArrayFromObjectByDate, getSortedArrayFromObjectByName} from '../../../../utils'
import {addCorporateDay, deleteCorporateDay} from '../../../../actions'
import HolidayList from './HolidayList'
import ScrollableContainer from '../../../../../../util/ScrollableContainer'
import {sortBy} from '../../../../constants'
import {createArrayOfObjectFromMap} from '../../../../../../atUtils'
import EmptyList from '../../components/EmptyList'

class HolidayListContainer extends TemplateView {
    constructor({
        changeSort,
        addCorporateDay,
        deleteCorporateDay,
        setListTransformed,
    }) {
        super()

        this.actions = {
            changeSort,
            addCorporateDay,
            deleteCorporateDay,
            setListTransformed,
        }

        this.state = {
            holidays: {},
            importedHolidayDates: {},
            selectedYear: '',
            sorting: {},
            isListTransformed: false
        }

        this.onStatePropertyChanged(['sorting'], () => {
            this.$dateSortArow.toggle(this.state.sorting.by === sortBy.DATE)
            this.$nameSortArow.toggle(this.state.sorting.by === sortBy.NAME)
            this.$dateSortArow.toggleClass('descArrow', this.state.sorting.by === sortBy.DATE && this.state.sorting.asc)
            this.$nameSortArow.toggleClass('descArrow', this.state.sorting.by === sortBy.NAME && this.state.sorting.asc)
        })

        this.onAnyStatePropertyDeeplyChanged(['holidays', 'isListTransformed'], () => {
            this.updateList()
        })

        this.onStatePropertyChanged('holidays', () => {
            const hasHolidays = Object.keys(this.state.holidays).length > 0
            this.$emptyListPlaceholder.toggle(!hasHolidays)
            this.$fillContainer.toggle(hasHolidays)
        })

        this.onStatePropertyChanged('selectedYear', () => {
            this.emptyList.setState({
                title: messageResource.getMessage('work_schedule.empty_list_title', [this.state.selectedYear])
            })
            if (Object.keys(this.state.holidays).length > 0) this.holidayList.forceUpdate()
        })

        this.onStatePropertyChanged('importedHolidayDates', (importedHolidays) => this.holidayList.setState({importedHolidays}))
    }

    templateHtml() {
        return '<div class="listContainer">' +
               '    <div class="fillContainer">' +
               '        <div class="listHeader">' +
               '            <div class="date">' +
               '                <%=date%>' +
               '                <div class="sortArrow"/>' +
               '             </div>' +
               '            <div class="separator"></div>' +
               '            <div class="holidayName">' +
               '                <%-holidayName%>' +
               '                <div class="sortArrow"/>' +
               '            </div>' +
               '        </div>' +
               '        <div class="listPlaceholder">' +
               '        </div>' +
               '    </div>' +
               '    <div class="emptyListPlaceholder"/>' +
               '</div>'
    }

    afterRender() {
        this.$fillContainer = this.find('.fillContainer')
        this.$emptyListPlaceholder = this.find('.emptyListPlaceholder')
        this.$dateSortArow = this.find('.date .sortArrow')
        this.$nameSortArow = this.find('.holidayName .sortArrow')

        this.emptyList = new ScrollableContainer(
            null,
            new EmptyList()
        ).init((this.$emptyListPlaceholder))

        this.holidayList = new ScrollableContainer(
            null,
            new HolidayList({
                addCorporateDay: this.actions.addCorporateDay,
                deleteCorporateDay: this.actions.deleteCorporateDay,
                updateListCallback: () => this.actions.setListTransformed(false)
            })
        ).init((this.find('.listPlaceholder')))

        this.find('.date').click(() => this.actions.changeSort({
            by: sortBy.DATE,
            asc: sortBy.DATE === this.state.sorting.by ? !this.state.sorting.asc : false
        }))
        this.find('.holidayName').click(() => this.actions.changeSort({
            by: sortBy.NAME,
            asc: sortBy.NAME === this.state.sorting.by ? !this.state.sorting.asc : false
        }))

        this.updateList()
    }

    messageKeys() {
        return {
            date: 'work_schedule.table_title_date',
            holidayName: 'work_schedule.table_title_holiday_name',
        }
    }

    updateList() {
        let dates = Object.keys(this.state.holidays)

        if (dates.length > 0) {

            let holidaysArray = []

            if (this.state.isListTransformed) {
                holidaysArray = this.state.sorting.by === sortBy.DATE
                    ? getSortedArrayFromObjectByDate(this.state.holidays, this.state.sorting.asc)
                    : getSortedArrayFromObjectByName(this.state.holidays, this.state.sorting.asc)
            } else {
                holidaysArray = createArrayOfObjectFromMap(this.state.holidays, createHolidayListObject)
            }

            this.holidayList.setState({
                holidays: holidaysArray,
                isListTransformed: this.state.isListTransformed
            })
        }
    }
}

export default connect(
    state => ({
        isShown: isShownHolidayList(state),
        holidays: getHolidays(state),
        importedHolidayDates: getImportedHolidayDatess(state),
        selectedYear: getPanelSelectedYear(state),
        sorting: getSorting(state),
        isListTransformed: isListTransformed(state)
    }),
    dispatch => ({
        changeSort: bindActionCreators(changeSort, dispatch),
        addCorporateDay: bindActionCreators(addCorporateDay, dispatch),
        deleteCorporateDay: bindActionCreators(deleteCorporateDay, dispatch),
        setListTransformed: bindActionCreators(setListTransformed, dispatch),
    }),
)(HolidayListContainer)



// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/panels/holidayList/components/HolidayListContainer.js